const semanticClassNames = {
  root: 'text-input',
  inputEl: 'text-input__input',
  inputLabel: 'text-input__label',
} as const;

export default semanticClassNames;
